import config from 'config/environment';

export enum ESegmentCategory {
  SIGN_UP_TRIGGERED = 'SIGN_UP_TRIGGERED',
  IMAGE_UPLOADED = 'IMAGE_UPLOADED',
  IMAGE_OUT_OF_FOCUS = 'IMAGE_OUT_OF_FOCUS',
  MANUAL_UPLOAD_IMAGE_SELECTED = 'MANUAL_UPLOAD_IMAGE_SELECTED',
  CAMERA_UPLOAD_IMAGE_SELECTED = 'CAMERA_UPLOAD_IMAGE_SELECTED',
  RETAKE_PHOTO = 'RETAKE_PHOTO',
  IMAGE_PROCESS_TIME_OUT = 'IMAGE_PROCESS_TIME_OUT',
  IMAGE_PROCESS_SUCCESS = 'IMAGE_PROCESS_SUCCESS',
  LOG_DEBUG = 'LOG_DEBUG',
  LOG_INFO = 'LOG_INFO',
  LOG_ERROR = 'LOG_ERROR',
  LOG_WARNING = 'LOG_WARNING',
}

export const loadSegment = () => {
  window.analytics.load(config.SEGMENT_ID);
};

/**
 * Records whenever a user sees a page on the website
 *
 * More Info: https://segment.com/docs/connections/spec/page/
 */
export const page = (params?: any) => {
  window.analytics.page({
    hostname: window.location.hostname,
    ...params,
  });
};

/**
 * @param eventName Identification of event
 * @param properties Properties to track
 *
 * More Info: https://segment.com/docs/connections/spec/track/
 */
export const track = (
  eventName: ESegmentCategory,
  properties?: Record<string, unknown>
) => {
  if (window.analytics) {
    window.analytics.track(eventName, {
      hostname: window.location.hostname,
      ...properties,
    });
  } else {
    const intervalId = setInterval(() => {
      if (window.analytics) {
        window.analytics.track(eventName, { ...properties });
        clearInterval(intervalId);
      }
    }, 100);
  }
};
